import { createContext, useContext, useEffect, useState } from "react";
import { useSocketContext } from "../../Components/Inbox/context/socketContext";
import { getSessionValue, constructEmitStr } from "../Appcommon";


const PopupContext = createContext();

const usePopupContext = () => useContext(PopupContext);

const PopupProvider = ({ children }) => {
	const socket = useSocketContext();
	const [callInfo, setCallInfo] = useState({});
	useEffect(() => {
		let userId = getSessionValue('loginuserid');
		let appid = getSessionValue('appid');
		if(appid !== ""){
			let prefix = constructEmitStr(appid, userId, "onincoming_call");
			if(socket !== undefined){
				socket.on(prefix, onIncomingCallMonitor);
			}
		}
	}, [socket]);

	 
	const onIncomingCallMonitor = (data) => {
		setCallInfo(data);
	}

	return (
		<PopupContext.Provider value={{ callInfo, onIncomingCallMonitor }}>
			{children}
		</PopupContext.Provider>
	);
};

export { usePopupContext, PopupProvider };
